import { createBreakpoints } from '@mui/system';

const breakpointDefinitions = {
  values: {
    xs: 0,
    sm: 768,
    md: 1024,
    lg: 1280,
    xl: 1420,
  },
};
export const breakpoints = createBreakpoints(breakpointDefinitions);
